import { Avatar } from '@/components/ui/avatar'
import { Typography } from '@/components/ui/typography'

import { getPersonAvatarSrc } from '../person-avatar'
import { getPersonFullName, PersonUser } from '../person-table.utils'
import * as S from './person-name-cell.styled'

interface PersonNameCellProps {
  subtitle?: string | null
  user: PersonUser
}

export const PersonNameCell = ({ subtitle, user }: PersonNameCellProps) => (
  <S.NameCell>
    <Avatar size="small" src={getPersonAvatarSrc(user.avatar)} />
    <div>
      <Typography color="black800" size="text-small" weight="medium" breakLines={1}>
        {getPersonFullName(user)}
      </Typography>
      {subtitle && (
        <Typography color="black500" size="text-small" weight="medium" breakLines={1}>
          {subtitle}
        </Typography>
      )}
    </div>
  </S.NameCell>
)
